import { compact } from 'lodash';

export enum PentestScanReport {
  InternalScanSummary = 1,
  InternalScanDetails = 2,
  ExternalScanSummary = 3,
  ExternalScanDetails = 4,
}

export namespace PentestScanReport {
  export function items(fromNessus: boolean, internal: boolean): PentestScanReport[] {
    return !fromNessus && internal
      ? [PentestScanReport.InternalScanSummary, PentestScanReport.InternalScanDetails]
      : compact([PentestScanReport.ExternalScanSummary, !fromNessus && PentestScanReport.ExternalScanDetails]);
  }

  export function mapToApiValue(pentestScanReport: PentestScanReport): string {
    switch (pentestScanReport) {
      case PentestScanReport.InternalScanDetails:
        return 'INTERNAL_SCAN_DETAILS';
      case PentestScanReport.InternalScanSummary:
        return 'INTERNAL_SCAN_SUMMARY';
      case PentestScanReport.ExternalScanSummary:
        return 'EXTERNAL_SCAN_SUMMARY';
      case PentestScanReport.ExternalScanDetails:
        return 'EXTERNAL_SCAN_DETAILS';
      default:
        return '';
    }
  }

  export const name = (pentestScanReport: PentestScanReport) => {
    switch (pentestScanReport) {
      case PentestScanReport.InternalScanSummary:
        return 'dashboard.pentestScanReports.internalScanSummary';
      case PentestScanReport.InternalScanDetails:
        return 'dashboard.pentestScanReports.internalScanDetails';
      case PentestScanReport.ExternalScanSummary:
        return 'dashboard.pentestScanReports.externalScanSummary';
      case PentestScanReport.ExternalScanDetails:
        return 'dashboard.pentestScanReports.externalScanDetails';
      default:
        return '';
    }
  };
}
